<template lang="pug">
v-card(:to="to")
  v-img.d-flex.justify-center.align-center(
    :src="img + '?resize=1&w=300'",
    :aspect-ratio="1",
    :width="width"
  )
    h6.font-weight-bold.px-2.text-uppercase.white--text.gallery-card-title.py-2.text-center {{ title }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    width() {
      let width;

      if (!this.xs) {
        if (!this.large) {
          width = "180px";
        } else {
          width = "100%";
        }
      } else width = "100%";

      return width;
    },
  },
};
</script>

<style>
.gallery-card-title {
  --factor: 8px;
  background: #0092b296;
  clip-path: polygon(
    0 var(--factor),
    100% 0,
    100% calc(100% - var(--factor)),
    0% 100%
  );
}
</style>
